import { React, useContext } from "react";
import { PageContext } from "../../App";
import { saveFile } from "../Utils";

function HTMLToImageOutputImageView() {
  //get context
  const { imageDetails, isConverting } = useContext(PageContext);

  return (
    <div
      className={`container mt-5 ${isConverting === false && imageDetails.imageBlob !== null ? "" : "d-none"}`}
    >
      {/*Image */}
      <div className="text-center ">
        <img
          className="border border-secondary"
          alt="html_to_image"
          src={
            imageDetails.imageBlob !== null
              ? URL.createObjectURL(imageDetails.imageBlob)
              : null
          }
          style={{
            width: "200px",
            height: "auto",
            maxWidth: "200px",
            maxHeight: "auto",
          }}
        />
      </div>
      {/* Download */}
      <div className="text-center mt-4">
        <button
          className="btn btn-success px-4 py-3 fs-4 rounded-3"
          onClick={async (e) => {
            //save blob
            saveFile(imageDetails.imageBlob, "html_to_image.jpeg");
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-download me-3"
            viewBox="0 0 16 16"
          >
            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
          </svg>
          Download (.jpeg)
        </button>
      </div>
    </div>
  );
}

export default HTMLToImageOutputImageView;
